<section class="contact-page section-main-padding">
  <div class="container">
    <h1 class="page-title">Contact Us</h1>

    <div class="contact-content">
      <div class="contact-info">
        <div class="info-item">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
              <circle cx="12" cy="10" r="3"></circle>
            </svg>
          </div>
          <div class="content">
            <h3>Our Location</h3>
            <p><span class="text-herbs">Herbs.</span><span class="text-lyf">LYF<sup>®</sup></span> Healthcare Products<br>Delhi, India</p>
          </div>
        </div>

        <div class="info-item">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </div>
          <div class="content">
            <h3>Email Address</h3>
            <p class="m-0">info&#64;herbslyf.com</p>
            <p class="m-0">herbslyfhealthcare&#64;gmail.com</p>
          </div>
        </div>

        <div class="info-item">
          <div class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path
                d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z">
              </path>
            </svg>
          </div>
          <div class="content">
            <h3>Phone Number</h3>
            <p>+91 1234567890</p>
          </div>
        </div>

        <div class="social-links">
          <h3>Follow Us</h3>
          <div class="links">
            <a href="https://www.facebook.com/herbslyfhealthcare" target="_blank" aria-label="Facebook">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
              </svg>
            </a>
            <a href="https://www.instagram.com/herbslyf/" target="_blank" aria-label="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
              </svg>
            </a>
            <a href="https://www.youtube.com/@HerbsLYFHealthcare" target="_blank" aria-label="YouTube">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z">
                </path>
                <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>
              </svg>
            </a>
          </div>
        </div>
      </div>

      <div class="contact-form">
        <div class="success-message" *ngIf="success">
          <p>Thank you for contacting us! We will get back to you soon.</p>
        </div>

        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="name">Full Name*</label>
            <input type="text" id="name" formControlName="name" placeholder="Enter your name"
              [ngClass]="{'invalid': submitted && f['name'].errors}">
            <div class="error-message" *ngIf="submitted && f['name'].errors">
              <span *ngIf="f['name'].errors['required']">Name is required</span>
              <span *ngIf="f['name'].errors['minlength']">Name must be at least 2 characters</span>
            </div>
          </div>

          <div class="form-group">
            <label for="email">Email Address*</label>
            <input type="email" id="email" formControlName="email" placeholder="Enter your email"
              [ngClass]="{'invalid': submitted && f['email'].errors}">
            <div class="error-message" *ngIf="submitted && f['email'].errors">
              <span *ngIf="f['email'].errors['required']">Email is required</span>
              <span *ngIf="f['email'].errors['email']">Please enter a valid email</span>
            </div>
          </div>

          <div class="form-group">
            <label for="phone">Phone Number*</label>
            <input type="tel" id="phone" formControlName="phone" placeholder="Enter your phone number"
              [ngClass]="{'invalid': submitted && f['phone'].errors}">
            <div class="error-message" *ngIf="submitted && f['phone'].errors">
              <span *ngIf="f['phone'].errors['required']">Phone number is required</span>
              <span *ngIf="f['phone'].errors['pattern']">Please enter a valid 10-digit phone number</span>
            </div>
          </div>

          <div class="form-group">
            <label for="subject">Subject*</label>
            <input type="text" id="subject" formControlName="subject" placeholder="Enter subject"
              [ngClass]="{'invalid': submitted && f['subject'].errors}">
            <div class="error-message" *ngIf="submitted && f['subject'].errors">
              <span *ngIf="f['subject'].errors['required']">Subject is required</span>
            </div>
          </div>

          <div class="form-group">
            <label for="message">Message*</label>
            <textarea id="message" formControlName="message" rows="5" placeholder="Enter your message"
              [ngClass]="{'invalid': submitted && f['message'].errors}"></textarea>
            <div class="error-message" *ngIf="submitted && f['message'].errors">
              <span *ngIf="f['message'].errors['required']">Message is required</span>
              <span *ngIf="f['message'].errors['minlength']">Message must be at least 10 characters</span>
            </div>
          </div>

          <div class="form-submit">
            <button type="submit" class="btn theme-btn">Send Message</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<app-gallery></app-gallery>
